import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

export default function FeaturedPupsSection({ pets, onViewCatalogue }) {
  const featured = useMemo(() => {
    const available = pets.filter((p) => {
      const s = String(p.status || '').trim().toLowerCase();
      return !(s === 'sold' || s === 'not available' || s === 'unavailable' || s === 'out of stock');
    });
    return available.slice(0, 6);
  }, [pets]);

  return (
    <section className="featured-pups" id="featured-pups">
      <div className="featured-pups-inner">
        <motion.div
          className="featured-pups-head"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
        >
          <h2>Featured Pups</h2>
          <p>Tap into the catalogue to see prices, availability, and send your request on WhatsApp.</p>
        </motion.div>

        {featured.length ? (
          <div className="featured-pups-grid">
            {featured.map((pet, idx) => (
              <motion.button
                key={pet.id}
                type="button"
                className="featured-pup-card"
                onClick={onViewCatalogue}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, delay: (idx % 6) * 0.03 }}
                whileHover={{ y: -6, scale: 1.01 }}
              >
                <div className="featured-pup-photo">
                  {pet.images?.[0] ? (
                    <img src={pet.images[0]} alt={pet.title} loading="lazy" />
                  ) : (
                    <div className="photo-placeholder" aria-hidden="true" />
                  )}
                </div>
                <div className="featured-pup-meta">
                  <div className="featured-pup-name">{pet.title}</div>
                  <div className="featured-pup-sub">
                    {pet.sex ? `${pet.sex} • ` : ''}
                    {typeof pet.price === 'number' ? `$${pet.price}` : 'Ask'}
                  </div>
                </div>
              </motion.button>
            ))}
          </div>
        ) : (
          <div className="featured-empty">
            <div className="featured-empty-title">No pups listed yet</div>
            <div className="featured-empty-sub">Check the catalogue soon — new pups are added regularly.</div>
          </div>
        )}

        <div className="featured-pups-actions">
          <button className="featured-pups-cta" type="button" onClick={onViewCatalogue}>
            View Full Catalogue
          </button>
        </div>
      </div>
    </section>
  );
}
